var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasicLayout',{attrs:{"left":_vm.left,"middle":_vm.middle,"right":_vm.right},scopedSlots:_vm._u([{key:"left_view",fn:function(){return [_c('PmNoRealReportLeftTree')]},proxy:true},{key:"right_view",fn:function(){return [_c('PmNoRealReportRightContent')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }